import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MapGridNotifier } from './map-grid-notifier';
import { MapGridState } from './map-grid-state';

@Injectable()
export class MapGridProvider extends BaseProvider<MapGridNotifier, MapGridState> {
  constructor() {
    super(MapGridNotifier);
  }
}
